export default function EmptyChat() {
    return(
        <div className="flex flex-col items-center justify-center h-full">
            <h2 className="text-2xl font-bold text-gray-700">No Chats Available</h2>
            <p className="text-gray-500">Start a conversation with someone!</p>
        </div>
    );
}
